import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  DeleteButton,
  DeleteWithConfirmButton,
  BooleanField,
} from "react-admin";
import { DatagridSX, ListSX } from "../../../styled/custom";
import CustomListDefaultToolbar from "../../../ui/custom-list-default-toolbar";
import CustomerExporter from "../../../exporter/customer-exporter";

const AffiliationRequestList = (props) => (
  <List
    title="Requisições de afiliação"
    sort={{ field: "id", order: "desc" }}
    filters={[]}
    exporter={CustomerExporter}
    actions={<CustomListDefaultToolbar />}
    sx={ListSX}
  >
    <Datagrid rowClick="show" bulkActionButtons={false} sx={DatagridSX}>
      <TextField source="id" sortable={true} />
      <TextField source="name" label="Nome" sortable={true} />
      <TextField source="email" label="Email" sortable={true} />
      <TextField source="phone" label="Telefone" sortable={false} />
      <TextField source="radioclass" label="Classe" sortable={false} />
      <TextField source="message" label="Mensagem" sortable={false} />
      <BooleanField source="active" label="Ativo" sortable={true} />

      <DateField
        source="created_at"
        locales="pt-BR"
        label="Criado em"
        sortable={false}
        showTime
      />
      <EditButton />
      <DeleteWithConfirmButton />
    </Datagrid>
  </List>
);

export default AffiliationRequestList;
